import type { FC } from 'react';
import useSettings from '../hooks/useSettings';
import { Container, Grid, Box } from '@mui/material';
import PageHeader from 'src/components/PageHeader';
import { getSettingsWidth } from 'src/utils/settingsHelper';

declare interface Props {
  pageHeaderTitle?: string;
  hasDivider?: boolean;
  displayOrderButton?: boolean;
  rightSideContent?: React.ReactNode;
  removeBottomMargin?: boolean;
  className?: string;
}

const PageContainerLayout: FC<React.PropsWithChildren<Props>> = ({
  children,
  pageHeaderTitle,
  displayOrderButton,
  rightSideContent,
  removeBottomMargin,
  hasDivider,
  className,
}) => {
  const contentWidth = useSettings((state) => state.settings.contentWidth);

  return (
    <Box sx={{ mb: 4 }}>
      <Container maxWidth={getSettingsWidth(contentWidth)} className={`container-width__${contentWidth} ${className}`}>
        <Grid container>
          <PageHeader
            displayOrderButton={displayOrderButton}
            rightSideContent={rightSideContent}
            headerTitle={pageHeaderTitle}
            removeBottomMargin={removeBottomMargin}
            hasDivider={hasDivider}
          />
          <Grid size={{ xs: 12 }}>{children}</Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default PageContainerLayout;
